export const collections = {
	applications: 'applications',
	profiles: 'profiles',
	families: 'families',
	education: 'educationRecords',
	scouting: 'scoutingRecords',
	expenses: 'expenseReports',
	incomes: 'incomeReports',
	contributions: 'contributions',
	projections: 'projections',
	attachments: 'attachments',
	applicants: 'applicants',
	members: 'members',
	siteConfig: 'siteConfiguration',
	emails: 'emails',
	sms: 'sms',
	sitelog: 'sitelog',
	presence: 'presence',
	dblog: 'dblog',
	requests: 'requests',
	users: 'authUsers',
	awards: 'awards',
	interviews: 'interviews',
	mailCache: 'mail_cache',
	mailSync: 'mail_sync',
	legacyFinances: 'legacy_financials',
	yearlyFinances: 'yearlyFinances',
	emailTemplates: 'emailTemplates',
	videoUsage: 'videoUsage',
	videoBudget: 'videoBudget',
	chatConfig: 'chatConfig',
	chatThreads: 'chatThreads',
} as const;

export type CollectionKey = keyof typeof collections;
export type CollectionId = (typeof collections)[CollectionKey];

export const applicationSpecificCollections = [
	collections.applications,
	collections.profiles,
	collections.families,
	collections.education,
	collections.scouting,
	collections.expenses,
	collections.incomes,
	collections.contributions,
	collections.projections,
	collections.attachments,
] as const;

export const ApplicationStatus = {
	started: 'Started',
	submitted: 'Submitted',
	completed: 'Completed',
	incomplete: 'Incomplete',
	eligible: 'Eligible',
	ineligible: 'Ineligible',
	invited: 'Invited',
	deferred: 'Deferred',
	awarded: 'Awarded',
	denied: 'Not Awarded',
	deleted: 'Deleted',
} as const;

export type ApplicationStatusKey = keyof typeof ApplicationStatus;
export type ApplicationStatusValue = (typeof ApplicationStatus)[ApplicationStatusKey];

export const ApplicationType = {
	newApplication: 'New Applicant',
	returningGrant: 'Returning Grant',
	scholarship: 'Scholarship Check In',
} as const;

export type ApplicationTypeKey = keyof typeof ApplicationType;
export type ApplicationTypeValue = (typeof ApplicationType)[ApplicationTypeKey];

export const InterviewStatus = {
	scheduled: 'Scheduled',
	invited: 'Invited',
	confirmed: 'Confirmed',
	inProgress: 'In Progress',
	completed: 'Completed',
	cancelled: 'Cancelled',
	missed: 'Missed',
} as const;

export type InterviewStatusKey = keyof typeof InterviewStatus;
export type InterviewStatusValue = (typeof InterviewStatus)[InterviewStatusKey];

export const UserType = {
	applicant: 'Applicant',
	member: 'Member',
	both: 'both',
} as const;

export type UserTypeKey = keyof typeof UserType;
export type UserTypeValue = (typeof UserType)[UserTypeKey];

export const UnitTypes = {
	pack: 'Pack',
	troop: 'Troop',
	crew: 'Crew',
	ship: 'Ship',
	other: 'Other',
	none: 'None',
} as const;

export const SearchableCollections = {
	applicants: {
		collection: collections.applicants,
		fields: ['firstName', 'lastName', 'callMe', 'cell', 'email'],
	},
	education: {
		collection: collections.education,
		fields: ['schoolName', 'major'],
	},
	scouting: {
		collection: collections.scouting,
		fields: ['unitNumber', 'unitType'],
	},
	profile: {
		collection: collections.profiles,
		fields: ['applicantFirstName', 'applicantLastName', 'applicantEmailAddress', 'applicantCellPhone'],
	},
} as const;

export const UploadType = {
	applicationAttachment: 'applications',
	applicantAvatar: 'applicants/avatars',
	memberAvatar: 'members/avatars',
} as const;
